import * as React from "react";
import Button from "@/components/atomics/button";
import Star from "@/components/atomics/star";

interface UnlockConfirmationModalProps {
  className?: string;
  onClose: () => void;
  onUnlock: () => void;
  rewardLabel: string;
  starCost: number;
}

export default function UnlockConfirmationModal({
  className,
  onClose,
  onUnlock,
  rewardLabel,
  starCost,
}: UnlockConfirmationModalProps) {
  return (
    <div className={className}>
      <div className="relative">
        <header className="relative flex justify-start items-center pl-[20px] pr-[20px] pt-[12px] pb-[12px] bg-primary-blue">
          <div className="text-[28px] text-center">
            <span>REWARD UNLOCK</span>
          </div>
          <div
            className="absolute right-[20px] w-[21px] h-[29px] hover:cursor-pointer"
            onClick={onClose}
          >
            <img src="/assets/cancel.svg" alt="cancel" />
          </div>
        </header>
        <main className="flex flex-col justify-center items-center pt-[58px] pb-[30px] pl-[49px] pr-[49px] text-[24px]">
          <p className="flex flex-col  mb-8">
            <span className="text-[24px] mb-4">
              Are you sure you want to unlock "{rewardLabel}"?
            </span>
          </p>

          <div className="flex gap-4 w-full">
            <div
              className="relative w-2/3 hover:cursor-pointer hover:scale-105 transition-transform duration-300 ease-in-out"
              onClick={onUnlock}
            >
              <img src="/assets/md-button.svg" alt="unlock" />
              <div className="absolute w-full h-full top-0 leading-none text-[20px] flex flex-col items-center justify-center pointer-events-none">
                <span className="text-white uppercase text-[24px]">unlock</span>
                <div className="flex items-center gap-2 text-primary-yellow uppercase text-[24px]">
                  <span>{starCost}</span>
                  <Star className="w-5 h-5" />
                </div>
              </div>
            </div>
            <div className="w-1/3">
              <Button
                className="w-full text-[20px] hover:cursor-pointer hover:scale-105 transition-transform duration-300 ease-in-out"
                image="/assets/sm-button.svg"
                text="NO"
                onClick={onClose}
              />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
